// API client for org-aware DataLens tree picker.
import { apiClient } from './client'

export interface DatalensTreeNode {
  key: string
  title: string
  nodeType: 'collection' | 'workbook' | 'dash'
  isLeaf: boolean
  children: DatalensTreeNode[]
  orgIds: string[]
  orgScopeSources: string[]
  orgScoped: boolean
}

export interface DatalensTreeResponse {
  tree: DatalensTreeNode[]
  cached: boolean
  org_id?: string | null
  filtered?: boolean
}

export const fetchDatalensTree = async (params?: {
  bust?: string
  org_id?: string
}): Promise<DatalensTreeResponse> => {
  const response = await apiClient.get<DatalensTreeResponse>(
    '/datalens/tree',
    { params, timeout: 60000 }
  )
  return response.data
}
